import { FkuSummary } from './fku-summary'
import { SkuConstraint } from './sku-constraint'

export class FkuConstraint {
  constructor(
    public summary: FkuSummary
    ) {
  }

  get isValid(): boolean {
    return this.fkuIsValid && this.allSkuConstraintsAreValid
  }

  get fkuIsValid(): boolean {
    return this.summary.totalCount <= this.summary.maxCount
  }

  get allSkuConstraints(): SkuConstraint[] {
    return this.summary.allSkuSummaries.map((summary) => {
      return new SkuConstraint(summary)
    })
  }

  get allSkuConstraintsAreValid(): boolean {
    return this.allSkuConstraints.every(constraint => constraint.isValid)
  }
}
